<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    title="Profil bearbeiten"
    iconPath="assets/icons/identification-card.svg"
  />

  <div class="p-6">
    <form class="mb-10 text-gray-600">
      <p class="mb-6">
        Scanne den QR-Code, um deine Teilnahme an der Veranstaltung zu registrieren. Halte dein
        Smartphone so, dass der Code im Kameraausschnitt zu sehen ist. Sobald dieser erkannt und
        verarbeitet wurde, ist deine Anwesenheit erfasst.
      </p>

      <div class="mt-5 mb-5 p-4 flex justify-between items-center bg-gray-100 rounded">
        <p class="">{{ data.activity.scheduledDate | dayjsFormat: 'dateWithWeekday' }}</p>
        <p class="">{{ activityTypeLabel }}</p>
      </div>

      <div class="overflow-hidden relative rounded aspect-[4/3] max-w-full min-w-full bg-gray-100">
        <div class="absolute z-10 top-0 left-0 w-full h-full flex justify-center items-center">
          <zxing-scanner
            *ngIf="requestState === null || requestState === RequestStateEnum.ERROR"
            [formats]="allowedFormats"
            (scanSuccess)="checkIn($event)"
          />
        </div>

        <div class="absolute z-0 top-0 left-0 w-full h-full flex justify-center items-center">
          <app-spinner />
        </div>
      </div>
    </form>
  </div>
</div>
